{
  "SymbolLabel": "Symbol:",
  "SymbolNote": "(Wendet automatisch Änderungen auf die Felder unten an)",
  "PatternLabel": "Muster:",
  "GroupingseparatorLabel": "Gruppierungstrennzeichen:",
  "GroupingseparatorOptionCommaDesc": "(Komma)",
  "GroupingseparatorOptionSpaceDesc": "(Platz)",
  "GroupingseparatorOptionFullstopDesc": "(Punkt)",
  "DecimalseparatorLabel": "Dezimaltrennzeichen:",
  "DecimalseparatorOptionFullstopDesc": "(Punkt)",
  "DecimalseparatorOptionColonDesc": "(Doppelpunkt)",
  "DecimalseparatorOptionCommaDesc": "(Komma)",
  "PreviewLabel": "Vorschau",
  "CurrencyDisplayFormat_SectionHeader": "Währungsanzeigeformat",
  "NAME": "CurrencyDisplayFormat"
}